import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { Box } from "@mui/material";
import { GoogleSvg } from "../CommonSvgs";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const gmailSettings = [
  {
    step: 1,
    description: "Open Gmail on your computer.",
  },
  {
    step: 2,
    description: "Click the ⚙️ gear icon in the top right corner.",
  },
  {
    step: 3,
    description: 'Click <b style="color: #3B4858;">All Settings</b>',
  },
  {
    step: 4,
    description:
      'Click the <a style="color: #016AFF;text-decoration:none; font-weight:bold;" href="https://mail.google.com/mail/u/0/#settings/fwdandpop" target="_blank">Forwarding and POP/IMAP</a> tab.',
  },
  {
    step: 5,
    description:
      'In the "IMAP access" section, select <b style="color: #3B4858;">Enable IMAP.</b>',
  },
  {
    step: 6,
    description: 'Click <b style="color: #3B4858;">Save Changes.</b>',
  },
];

const GenerateAppPasswordModal = ({
  openAppPasswordModal,
  setOpenAppPasswordModal,
}) => {
  const handleOnclick = () => {
    setOpenAppPasswordModal(true);
  };
  return (
    <Dialog
      open={openAppPasswordModal}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => setOpenAppPasswordModal(false)}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <GoogleSvg />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                fontWeight: 700,
                color: "#000",
                fontSize: "18px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              Connect Your Google Account
            </p>
            <span
              style={{
                fontWeight: 600,
                color: "#868686",
                fontSize: "14px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
                marginTop: "-4px",
              }}
            >
              Gmail / G-Suite
            </span>
          </div>
        </div>
      </DialogTitle>
      <DialogContent
        id="alert-dialog-slide-description"
        sx={{ paddingBottom: "0px" }}
      >
        <Box
          sx={{
            borderBottom: "1px solid #DDD",
            padding: "6px 0px",
            textAlign: "center",
          }}
        >
          <p
            style={{
              fontWeight: 400,
              color: "#000",
              fontSize: "14px",
              letterSpacing: "0.7px",
              fontFamily: "Source Sans 3",
              fontStyle: "normal",
            }}
          >
            First, let's{" "}
            <b
              style={{
                color: "#016AFF",
              }}
            >
              enable IMAP
            </b>{" "}
            access <br /> for your Google account.
          </p>
        </Box>
        <ul
          style={{
            padding: "10px 0px",
            display: "flex",
            flexDirection: "column",
            gap: 6,
          }}
        >
          {gmailSettings.map((item) => (
            <li
              style={{
                listStyleType: "none",
                fontWeight: 400,
                display: "flex",
                alignItems: "flex-start",
                gap: 4,
                color: "#000",
                fontSize: "14px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              <span style={{ fontWeight: 700 }}>{item.step}.</span>{" "}
              <span dangerouslySetInnerHTML={{ __html: item.description }} />
            </li>
          ))}
        </ul>
      </DialogContent>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
          paddingBottom: 14,
        }}
      >
        <button
          onClick={() => setOpenAppPasswordModal(false)}
          style={{
            backgroundColor: "transparent",
            fontWeight: 400,
            color: "#868686",
            fontSize: "14px",
            letterSpacing: "0.7px",
            fontFamily: "Source Sans 3",
            fontStyle: "normal",
            padding: "6px 0px",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          Show me how <KeyboardArrowRightIcon />{" "}
        </button>
        <button
          onClick={() => handleOnclick()}
          style={{
            backgroundColor: "#FF3301",
            fontWeight: 400,
            color: "#FFF",
            fontSize: "14px",
            letterSpacing: "0.7px",
            fontFamily: "Source Sans 3",
            fontStyle: "normal",
            padding: "6px 14px",
            borderRadius: 5,
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          Yes, IMAP has been enabled <KeyboardArrowRightIcon />{" "}
        </button>
      </div>
    </Dialog>
  );
};

export default GenerateAppPasswordModal;
